import { API_CHAT_CREATE_ROOM, API_CLEARE_CHAT_HISTORY } from "../constants/api";
import { API } from "../constants/types";

export const clearechatHistoryAction = (id) => ({
  type: API,
  payload: {
    url: API_CLEARE_CHAT_HISTORY + id,
    method: "DELETE",
  },
});

export const createChatRoomAction = (data) => ({
  type: API,
  payload: {
    url: API_CHAT_CREATE_ROOM,
    method: "POST",
    data: data,
  },
});